import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getHomepageUrl } from '@as-react/common-utils';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BasketAPI from '../../../api/basket/BasketAPI';
import { DELAY } from '../../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { BasketSaveFormState, BasketSaveForm } from '../basket-save-form/BasketSaveForm';
export const BasketPersonalShoppingAdvice = ({ root, defaultRequestParams, servicesEndpoint, isHorizontal, }) => {
    const { t } = useTranslation([I18N_NAMESPACES.checkout, I18N_NAMESPACES.form]);
    const [formState, setFormState] = useState(BasketSaveFormState.INPUT);
    const handleSubmit = (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ email }, { setFieldError }) {
        var _c;
        if (formState !== BasketSaveFormState.INPUT)
            return;
        setFormState(BasketSaveFormState.SUBMITTING);
        try {
            yield BasketAPI.personalShoppingAdviceSendMail(email, servicesEndpoint, defaultRequestParams);
            setFormState(BasketSaveFormState.COMPLETE);
            setTimeout(() => (window.location.href = getHomepageUrl(root)), DELAY.DELAY_3000);
        }
        catch (error) {
            const { response } = error;
            setFieldError('email', (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.message);
            setFormState(BasketSaveFormState.INPUT);
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx(Box, { paddingBlockEnd: "2", children: _jsx(TextAlpha, { as: "h2", variant: "subheadingM", children: t(`${I18N_NAMESPACES.checkout}:checkout.basket.psa.title`) }) }), _jsx(BasketSaveForm, { onSubmit: handleSubmit, state: formState, isHorizontal: isHorizontal })] }));
};
